var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cb-carousel-item item"},[_vm._t("default"),(_vm.label)?_c('div',{staticClass:"carousel-caption"},[_vm._v(_vm._s(_vm.label))]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }